import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
export function RuiChipList({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("ul", {
    ...props,
    class: cx("rui-chip-list", className),
    children
  });
}
export function RuiChipListItem({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("li", {
    ...props,
    class: cx("rui-chip-list__item", className),
    children
  });
}